export default "/images/vendor/flag-icon-css/flags/4x3/gu.svg?795bcfa73f67bb1c7448bd89ff536c6a";